export const defaultData = [
  [
    [0, 1, 30, 0, '∿1'],
    [1, 150, 10, 30, '∿2'],
    [2, 1, 200, 110, '∿3'],
    [3, 20, 50, 118, '∿4'],
    [4, 1, 100, 26, '∿5'],
    [5, 0, 100, 0, 'scan'],
    [6, 0, 2.09, 0, 'rota'],
    [7, 0.5, 0.1, 60, 'zoom'],
    [8, -1, 2, 45, 'brightness'],

    [9, 0.65, 1, 127, 'contrast'],
    [10, 0, 2, 127, 'saturation'],
    [11, 0, 6.28, 127, 'hue'],

    [12, .4, 0, 60, '∿R'],
    [13, .4, 0, 9, '∿G'],
    [14, .3, 0, 83, '∿B'],
    [15, 1., 0.98, 0, 'Δ']
  ], 
  [
    [0, 1, 90, 1, '∿1'],
    [1, 1, 100, 127, '∿2'],
    [2, 1, 100, 100, '∿3'],
    [3, 0, 100, 127, '∿4'],
    [4, -100, 100, 100, '∿5'],
    [5, -100, 100, 0, '∿6'],
    [6, -0.50, 0.5, 42, 'rota'],
    [7, .4, .1, 63, 'zoom'],
    [8, 0, 2, 68, 'brightness'],
    
    [9, 0.65, 1, 71, 'contrast'],
    [10, 0, 2, 60, 'saturation'],
    [11, 0, 6.28, 127, 'hue'],

    [12, .4, 0, 30, '∿R'],
    [13, .4, 0, 0, '∿G'],
    [14, .3, 0, 10, '∿B'],
    [15, 1., 0.98, 0, 'Δ']
  ], 
  [
    [0, 0, 5, 119, '∿1'],
    [1, 0., 5.0, 26, '∿2'],
    [2, 10, 30, 99, '∿3'],
    [3, 0, 15, 0, '∿4'],
    [4, 1, 7, 40, '∿5'],
    [5, 0.1, 1, 31, '∿6'],
    [6, 15, 80, 100, '∿7'],
    [7, 0, 1.5, 110, 'warp'],
    [8, -2, 1, 31, 'brightness'],

    [9, 0.65, 1, 127, 'contrast'],
    [10, 0, 2, 127, 'saturation'],
    [11, 0, 6.28, 127, 'hue'],

    [12, .4, 0, 101, '∿R'],
    [13, .4, 0, 39, '∿G'],
    [14, .3, 0, 92, '∿B'],
    [15, 1., 0.98, 18, 'Δ']
  ]
]